import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { DeleteIcon, LogoIcon } from "../../../icons";

const WatchListItem = props => {
  const { orgItem, handleWatching } = props;

  return (
    <div className="events-page-myorg-content-row-box">
      <Link
        to={`/company/${orgItem?.orgSlug}`}
        className="events-page-myorg-content-row-box-logo"
        style={{
          backgroundColor: orgItem?.orgLogoColor ? orgItem?.orgLogoColor : "",
        }}
      >
        {orgItem?.orgLogo ? (
          <img src={orgItem?.orgLogo} alt="logo" />
        ) : (
          <LogoIcon />
        )}
      </Link>
      <div className="events-page-myorg-content-row-box-info">
        <Link
          to={`/company/${orgItem?.orgSlug}`}
          className="events-page-myorg-content-row-box-info-name"
        >
          {orgItem?.orgName}
        </Link>
      </div>
      <div className="events-page-myorg-content-row-box-action">
        <Button
          variant="outlined"
          className="events6ix-btn events6ix-btn-light events6ix-btn-sm"
          type="button"
          sx={{ textTransform: "none" }}
          startIcon={<DeleteIcon active />}
          onClick={() => {
            handleWatching(orgItem?._id);
          }}
        >
          Remove
        </Button>
      </div>
    </div>
  );
};

export default WatchListItem;
